import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/core/data.service';
import * as FileSaver from 'file-saver';

@Injectable()
export class UploadService {
  constructor(private dataService: DataService) { }

  // To delete the file from the database...
  public deleteFile(fileName: string): Observable<any> {
    return this.dataService.getRequest(
      'general/DeleteFile?fileName=' + fileName
    );
  }

  // To upload and scan the file..
  public uploadScanFile(formData: FormData): Observable<any> {
    return this.dataService.fileScanRequest('Scan/UploadFiles', formData);
  }

  // To insert file into the database..
  public insertFile(formData: any, folderPath: string): Observable<any> {
    return this.dataService.fileUploadRequest(
      'general/InsertFile?folderPath=' + folderPath,
      formData
    );
  }

  public getFile(fileUrl, fileName): any {
    return this.dataService.getUploadedFileContent(
      'general/DownloadFile?fileUrl=' + fileUrl
    );
  }

  public downloadFile(filePath, fileName) {
    this.getFile(filePath, fileName).subscribe((res) => {
      this.displayContents(res, fileName)
    });
  }

  displayContents(fileDetails, fileName: any) {
    let fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    let mimetype = this.getMimetype(fileExtension);

    const byteArray = new Uint8Array(atob(fileDetails.file).split('').map(char => char.charCodeAt(0)));
        var blobData = new Blob([byteArray], { type: mimetype });
        FileSaver.saveAs(blobData, fileName);
        var fileURL: any = URL.createObjectURL(fileDetails.url);

  }

  private getMimetype(extension) {
    let mimetype;

    switch (extension) {
      case '.gif':
        mimetype = 'image/gif';
        break;
      case '.jpeg':
      case '.jpg':
        mimetype = 'image/jpeg';
        break;
      case '.heic':
        mimetype = 'image/heic';
        break;
      case '.xls':
        mimetype = 'application/vnd.ms-excel';
        break;
      case '.pptx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        break;
      case '.xlsx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case '.docx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case '.dotx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.template';
        break;
      case '.ppt':
        mimetype = 'application/vnd.ms-powerpoint';
        break;
      case '.pptm':
        mimetype = 'application/vnd.ms-powerpoint.presentation.macroenabled.12';
        break;
      case '.doc':
        mimetype = 'application/msword';
        break;
      case '.pdf':
        mimetype = 'application/pdf';
        break;
      default:
        break;
    }

    if (mimetype) {
      return mimetype;
    }
  }
}

//  private displayContents(binaryString) {
//    let len = binaryString.length;
//    let arr = new Uint8Array(len);
//    for (let i = 0; i < len; i++) {
//      arr[i] = binaryString.charCodeAt(i);
//    }
//    let mimetype = 'application/pdf';

//    let data = new Blob([arr], {
//      type: mimetype,
//    });
//      let dataURL = window.URL.createObjectURL(data);
//      window.open(dataURL, '_blank');
//  }

//}
